import moment from 'moment';

export default function getDifferenceBetweenDateYearsMonthsDays(dateDebutSend, dateFinSend) {
  if (!dateDebutSend || !dateFinSend) return null;
  const dateFin = (moment(dateFinSend).startOf('day')).add(1, 'd');
  const dateDebut = moment(dateDebutSend).startOf('day');

  const years = dateFin.diff(dateDebut, 'year');
  dateDebut.add(years, 'years');

  const months = dateFin.diff(dateDebut, 'months');
  dateDebut.add(months, 'months');

  const days = dateFin.diff(dateDebut, 'days');
  dateDebut.add(days, 'days');
  return { years, months, days };
}
